<template>
  <Layout>
    <div class="login-wrapper">
      <div id="preloader" v-if="autoLoginByPassportID">
        <div id="status">
          <div class="spinner-chase">
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
          </div>
        </div>
      </div>
      <div v-else class="login" :class="{ autoLoginCard: getWillAutoLogin }">
        <div v-if="getWillAutoLogin" class="auto-login-wrapper">
          <div class="logo-wrapper">
            <img
              src="@/assets/images/logo-lg.svg"
              class="unselectable mx-auto"
              alt
              width="86px"
              height="16px"
            />
          </div>
          <div class="text-primary">
            <h3 class="text-primary">Welcome to your passport account</h3>
            <p>loading, please wait ....</p>
          </div>
          <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="login-form" v-else>
          <div class="logo-wrapper">
            <img
              src="@/assets/images/logo-lg.svg"
              class="unselectable mx-auto"
              alt
              width="86px"
              height="16px"
            />
          </div>
          <div class="info">
            <p class="login-title">PASSPORT ACCOUNT</p>
            <p class="login-subtitle">{{this.$route.query.add_visitor ? 'Confirm your visit invitation' : 'Login'}}</p>
          </div>
          <div>
            <b-form @submit.prevent="tryToLogIn" novalidate>
              <!-- email or phone  -->
              <div class="email-phone-wrapper">
                <div
                  class="form-group m-d-gruop"
                  :class="$v.email.$error && 'invalid-value'"
                >
                  <b-form-input
                    id="email"
                    v-model.trim="email"
                    type="text"
                    required
                    class="form-control"
                    :disabled="this.$route.query.add_visitor"
                    @input="emailNotFound = false"
                  />
                  <label for="email" class="email-label"
                    >Email Address or Phone Number</label
                  >
                </div>
                <div class="err-wrapper">
                  <div v-if="submitted && !$v.email.required">
                    <span class="error-value">Email or phone is required.</span>
                  </div>
                  <div v-if="emailNotFound && $v.email.required">
                    <span class="error-value"
                      >Email address not found, use a different one</span
                    >
                  </div>
                  <div
                    v-if="phoneNotFound && !emailNotFound && $v.email.required"
                  >
                    <span class="error-value"
                      >Phone Number not found, use a different one</span
                    >
                  </div>
                </div>
              </div>
              <!-- password  -->
              <div class="password-wrapper">
                <div class="form-group m-d-gruop">
                  <b-form-input
                    id="password"
                    v-model="password"
                    type="password"
                    required
                  />
                  <label for="password" class="password-label">Password</label>
                </div>
              </div>
              <!-- forget password  -->
              <div class="forget-password-wrapper">
                <router-link
                  v-if="!$route.query || (!$route.query.redirect_url && !$route.query.add_visitor)"
                  tag="a"
                  to="/forget-password"
                  class="forget-password"
                  >Forgot password?</router-link
                >
              </div>
              <!-- submit btn  -->
              <div class="login-action">
                <b-button
                  type="submit"
                  :class="
                    loadingStatus || !(this.password && $v.email.required)
                      ? 'submit-btn dimmed-btn'
                      : 'submit-btn activ-btn'
                  "
                  :disabled="
                    loadingStatus || !(this.password && $v.email.required)
                  "
                >
                  <i
                    v-if="loadingStatus"
                    class="bx bx-loader bx-spin font-size-16 align-middle mr-2"
                  ></i>
                  <span v-else> Login </span>
                </b-button>
              </div>
              <!-- one time login -->
              <div class="one-time-login-wrapper">
                <p class="one-time-login-title">
                  Or use the button below to login without a password
                </p>
                <div class="one-time-login-action">
                  <button
                    @click="oneTimeLoginClick"
                    class="one-time-btn"
                    :disabled="loadingStatus || !$v.email.required"
                    :class="{ disableBtn: loadingStatus || !$v.email.required }"
                  >
                    <span>ONE TIME LOGIN</span>
                  </button>
                </div>
              </div>
              <!-- register if no acc  -->
              <div
                class="register-wrapper"
                v-if="!$route.query || (!$route.query.redirect_url && !$route.query.add_visitor)"
              >
                <p class="register-title">Don’t have an account?</p>
                <router-link
                  to="/register-selector"
                  custom
                  v-slot="{ navigate }"
                >
                  <span
                    class="register-redirect"
                    @click="navigate"
                    @keypress.enter="navigate"
                    role="link"
                    >Signup</span
                  >
                </router-link>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/auth";
import UserService from "../../../services/userService";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      emailNotFound: false,
      phoneNotFound: false,
      showModal: false,
      email: "",
      password: "",
      code: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      loader: this.$store ? this.$store.state.layout.loader : {} || {},
      servers: [],
      autoLoginByPassportID: false,
    };
  },
  validations: {
    email: {
      required,
    },
  },
  computed: {
    ...mapGetters("authfack", [
      "loadingStatus",
      "getWillAutoLogin",
      "getUserName",
      "getAutoLoginByPassportID",
    ]),
    ...mapGetters("user", ["getEncPwd", "getEncEmail", "getCode"]),
  },
  methods: {
    ...mapActions("authfack", [
      "resetLoading",
      "changeWillAutoLogin",
      "login",
      "generatePassportToken",
      "resetOneTimeCodeSent",
      "checkDuplicated",
    ]),
    tryToLogIn() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const { email, password, code } = this;
        if (email && password) {
          const data = {
            email,
            password,
            preRegData: this.$route.query,
          };
          if (code) data.code = code;
          this.login(data);
          this.$store.commit("user/setEncPwd", null);
          this.$store.commit("user/setEncEmail", null);
          this.$store.commit("user/setCode", null);
        }
      }
    },
    oneTimeLoginClick() {
      this.password = null;
      let obj;
      if (this.$v.email.required) {
        if (Number.isNaN(parseInt(this.email))) {
          this.phoneNotFound = false;
          this.checkDuplicated({ field: "email", value: this.email })
            .then((res) => {
              this.emailNotFound = res.data?.data?.available;
              if (!this.emailNotFound) {
                obj = {
                  email: this.email,
                };
                if (this.$route.query.redirect_url) {
                  obj.entity_id = this.$route.query.entity_id;
                  obj.user_type_id = this.$route.query.user_type_id;
                  obj.area_id = this.$route.query.area_id;
                  obj.registration_method = this.$route.query.registration_method;
                  obj.journey_flow_id = this.$route.query.journey_flow_id;
                  obj.redirect_url = this.$route.query.redirect_url;
                } else if (this.$route.query.add_visitor) {
                  obj.add_visitor = this.$route.query.add_visitor;
                  obj.visit_url = this.$route.query.visit_url;
                  obj.serverUrl = this.$route.query.serverUrl;
                }
                this.$router.push({
                  name: "loginOneTime",
                  query: obj,
                });
              }
            })
            .catch((err) => console.log(err));
          // this.$router.push({
          //   name: "loginOneTime",
          //   query: { email: this.email },
          // });
        } else {
          this.emailNotFound = false;
          this.checkDuplicated({ field: "phone", value: this.email })
            .then((res) => {
              this.phoneNotFound = res.data?.data?.available;

              if (!this.phoneNotFound) {
                obj = { phone: this.email };
                if (this.$route.query.redirect_url) {
                  obj.entity_id = this.$route.query.entity_id;
                  obj.user_type_id = this.$route.query.user_type_id;
                  obj.area_id = this.$route.query.area_id;
                  obj.registration_method = this.$route.query.registration_method;
                  obj.journey_flow_id = this.$route.query.journey_flow_id;
                  obj.redirect_url = this.$route.query.redirect_url;
                } else if (this.$route.query.add_visitor) {
                  obj.add_visitor = this.$route.query.add_visitor;
                  obj.visit_url = this.$route.query.visit_url;
                  obj.serverUrl = this.$route.query.serverUrl;
                }
                this.$router.push({
                  name: "loginOneTime",
                  query: obj,
                });
              }
            })
            .catch((err) => console.log(err));
          // this.$router.push({
          //   name: "loginOneTime",
          //   query: { phone: this.email },
          // });
        }
      } else {
        this.submitted = false;
      }
    },
  },
  beforeCreate() {
    localStorage.setItem("serverId", process.env.VUE_APP_PASSPORT_KEY);
    axios
      .get(`${process.env.VUE_APP_BASE_URL}/api/list-all-servers`)
      .then((data) => {
        this.servers = data.data.data;
        this.servers.map(async (server) => {
          let name = server.server_name;
          if (name.indexOf("https://") > -1)
            name = name.replace("https://", "");
          if (name.indexOf("http://") > -1) name = name.replace("http://", "");
          if (!JSON.parse(localStorage.getItem(name))) {
            let secretkey = await UserService.getSecretKey(server.server_api)
              .then((data) => {
                if (data.data.data) return data.data.data;
              })
              .catch((err) => {
                console.log(err);
              });
            let cloudAccesstoken = await UserService.getCloudToken(
              server.server_api,
              secretkey
            )
              .then((data2) => {
                if (data2.data.data) return data2.data.data.access_token;
              })
              .catch((err) => {
                console.log(err);
              });
            localStorage.setItem(name, JSON.stringify(cloudAccesstoken));
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  },
  beforeMount() {
    this.resetOneTimeCodeSent();
    const { params } = this.$route;
    if (params.passport_id) {
      this.autoLoginByPassportID = true;
      this.generatePassportToken(params.passport_id);
    }
  },
  mounted() {
    if (this.getUserName) {
      this.email = this.getUserName;
    } else if (this.$route.query.email) {
      this.email = decodeURIComponent(this.$route.query.email);
    } else if (this.$route.query.phone) {
      this.email = decodeURIComponent(this.$route.query.phone);
    }
    this.resetLoading();
    if (this.getEncPwd !== null && this.getEncEmail !== null) {
      this.email = this.getEncEmail.replaceAll('"', "");
      this.password = this.getEncPwd.replaceAll('"', "");
      if (this.getCode !== null) this.code = this.getCode.replaceAll('"', "");
      this.changeWillAutoLogin(true);
      this.$store.commit("user/setEncPwd", null);
      this.$store.commit("user/setEncEmail", null);
      this.$store.commit("user/setCode", null);
      this.tryToLogIn();
    }
  },
};
</script>

<style lang="scss" scoped>
.m-d-gruop > .form-control:disabled ~ label {
  font-family: 'Lato';
font-style: normal;
font-weight: 700!important;
font-size: 10px!important;
line-height: 17px!important;
/* or 170% */

letter-spacing: 0.25px!important;

/* Main Button */

color: #103F5E!important;
bottom: 33px;
opacity: 0.3!important;
}

input#email:disabled {
  font-family: 'Lato';
font-style: normal;
font-weight: 600!important;
font-size: 14px!important;
line-height: 17px!important;
/* identical to box height, or 121% */

letter-spacing: 0.25px!important;

color: rgba(0, 0, 0, 0.87)!important;
top: 15px;
opacity: 0.3!important;

}
.disableBtn {
  opacity: 0.7;
}
.dimmed-btn {
  background-color: #96abb8;
  cursor: not-allowed;
}
.activ-btn {
  background-color: #103f5e;
  pointer-events: auto;
}
.email-label {
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0.25px;
}
.password-label {
  font-size: 14px;
  font-weight: 400;
}
.login-wrapper {
    width: 494px;
    margin:auto;
    .login-form {
      border-radius: 26px;
      margin: 97px auto 87px auto;
      padding: 46px 40px 51px 40px;
      background: #FFFFFF;
      .logo-wrapper {
        margin:0px auto 21px auto;
        width:86px;
        height:16px;
      }
      .info {
        .login-title {
          margin-bottom: 9px;
          font-family: 'SF Pro Display';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 19px;

text-align: center;

color: #000000;
        }
        .login-subtitle {
          font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 19px;
text-align: center;

color: rgba(0, 0, 0, 0.28);
          margin-bottom: 51px;
        }
      }
      .forget-password-wrapper {
        margin-bottom: 41px;
        padding-left: 15px;
        .forget-password {
          font-family: 'Lato';
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 17px;
/* identical to box height, or 121% */

text-align: right;
letter-spacing: 0.25px;

/* #666666 */

color: #666666;

opacity: 0.8;
        }
      }
      .login-action {
        margin-bottom: 34px;
        .submit-btn {
          font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 17px;
/* identical to box height, or 106% */

text-align: center;
letter-spacing: 0.25px;
text-transform: uppercase;

color: #FFFFFF;
          width: 415px;
          height: 44px;
          border-radius: 22px;
        }
      }
      .one-time-login-wrapper {
        .one-time-login-title {
          font-family: 'Lato';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 20px;
/* identical to box height, or 125% */

text-align: center;
letter-spacing: 0.25px;

/* #666666 */

color: #666666;

mix-blend-mode: normal;
          margin-bottom: 34px;
        }
      }
      .one-time-login-action {
      
        .one-time-btn {
          margin-bottom: 51px;
        border: 3px solid #103F5E;
border-radius: 22px;
width:415px;
height:44px;
font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 17px;
/* identical to box height, or 106% */

text-align: center;
letter-spacing: 0.25px;
text-transform: uppercase;
color: #103F5E;
        }
      }
      .register-wrapper {
        .register-title {
          margin-bottom: 22px;
          
          font-family: 'Lato';
font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 19px;
text-align: center;

color: rgba(0, 0, 0, 0.28);
        }
        span.register-redirect {
          font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 19px;
text-align: center;
text-transform: uppercase;
margin-left:176px;
color: #103F5E;
cursor: pointer;
}
      }
    }

    .email-label {
      font-size: 16px;
    }
    .password-label {
      font-size: 16px;
    }
  }
// .login-wrapper {
//   background: red;

// width: 494px;
// box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
// border-radius: 26px;
//   .auto-login-wrapper {
//     background-color: #fff;
//     width: 494px;
//     text-align: center;
//   }
//   .login-form {
//     background-color: #fff;
//     padding: 73px 26px 148px 26px;
//     .logo-wrapper {
//       display: flex;
//       justify-content: center;
//       margin-bottom: 27px;
//     }
//     .info {
//       text-align: center;
//       .login-title {
//         font-size: 16px;
//         font-weight: 700;
//         letter-spacing: 0.25px;
//         text-align: center;
//         margin-bottom: 11px;
//       }
//       .login-subtitle {
//         font-style: normal;
//         font-weight: bold;
//         font-size: 14px;
//         color: rgba(0, 0, 0, 0.28);
//         margin-bottom: 84px;
//       }
//     }
//     .form-group {
//       margin-bottom: 0;
//     }
//     .err-wrapper {
//       padding-left: 20px;
//       margin-bottom: 0;
//     }
//     .email-phone-wrapper {
//       margin-bottom: 14px;
//     }
//     .password-wrapper {
//       margin-bottom: 10px;
//     }
//     .forget-password-wrapper {
//       padding-left: 19px;
//       margin-bottom: 27px;
//       .forget-password {
//         color: #666666;
//         font-weight: 500;
//         font-size: 14px;
//         cursor: pointer;
//         opacity: 0.8;
//       }
//     }
//     .login-action {
//       margin-bottom: 33.86px;
//       .submit-btn {
//         text-transform: uppercase;
//         font-weight: 500;
//         color: rgba(255, 255, 255, 0.87);
//         display: block;
//         width: 309px;
//         height: 37px;
//         margin: 0 auto 20px auto;
//         border-radius: 18.5px;
//         font-size: 16px;
//         line-height: 17px;
//         text-align: center;
//       }
//     }
//     .one-time-login-wrapper {
//       .one-time-login-title {
//         font-size: 13px;
//         font-weight: 400;
//         line-height: 20px;
//         letter-spacing: 0.25px;
//         text-align: center;
//         margin-bottom: 20px;
//       }
//     }
//     .one-time-login-action {
//       margin-bottom: 40px;
//       .one-time-btn {
//         margin-bottom: 0 !important;
//         font-weight: 700;
//         background-color: #fff;
//         color: #103f5e;
//         display: block;
//         width: 309px;
//         height: 37px;
//         margin: 0 auto 20px auto;
//         border: 3px solid #103f5e;
//         border-radius: 18.5px;
//         font-size: 16px;
//         text-align: center;
//         line-height: 32px;
//       }
//     }
//     .register-wrapper {
//       text-align: center;
//       .register-title {
//         color: rgba(0, 0, 0, 0.28);
//         font-size: 16px;
//         font-weight: 500;
//         margin-bottom: 13px;
//       }
//       .register-redirect {
//         font-weight: bold;
//         font-size: 16px;
//         text-align: center;
//         text-transform: uppercase;
//         color: #103f5e;
//         margin-bottom: 0;
//         cursor: pointer;
//       }
//     }
//   }
// }
@media (max-width: 992px) {
  .login-wrapper {
    width: 360px;
    margin: auto;
    .login-form {
      border-radius: 0px;
      margin: 0px auto;
      padding: 73px 26px 98px 26px;
      .logo-wrapper {
        margin-bottom: 27px;
        width:116px!important;
        height: 22px!important;
         img{
        width:116px!important;
        height: 22px!important;
      
    }
      }
      .info {
        .login-title {
          margin-bottom: 11px;
          font-family: 'SF Pro Display';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 19px;
/* identical to box height */

text-align: center;

color: #000000;
        }
        .login-subtitle {
          font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 17px;


text-align: center;

color: rgba(0, 0, 0, 0.28);
          margin-bottom: 134px;
        }
      }
      .forget-password-wrapper {
        margin-bottom: 27px;
        padding-left: 14px;
        .forget-password {
          font-family: 'Lato';
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 17px;
/* identical to box height, or 121% */

text-align: right;
letter-spacing: 0.25px;

/* #666666 */

color: #666666;

opacity: 0.8;
        }
      }
      .login-action {
        margin-bottom: 20px;
        .submit-btn {
          font-family: 'Lato';
font-style: normal;
font-weight: 500;
font-size: 16px;
line-height: 17px;
/* identical to box height, or 106% */

text-align: center;
letter-spacing: 0.25px;
text-transform: uppercase;

color: #FFFFFF;
          width: 309px;
          height: 37px;
          border-radius: 18.5px;
        }
      }
      .one-time-login-wrapper {
        .one-time-login-title {
          font-family: 'Lato';
font-style: normal;
font-weight: 400;
font-size: 13px;
line-height: 20px;
/* or 154% */

text-align: center;
letter-spacing: 0.25px;

/* #666666 */

color: #666666;

mix-blend-mode: normal;
          margin-bottom: 19px;
        }
      }
      .one-time-login-action {
      
        .one-time-btn {
          margin-bottom: 43px;
        border: 2px solid #103F5E;
border-radius: 18.5px;
width:309px;
height:37px;
font-family: 'Lato';
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 17px;
text-align: center;
letter-spacing: 0.25px;
text-transform: uppercase;
color: #103F5E;
        }
      }
      .register-wrapper {
        .register-title {
          margin-bottom: 13px;
          
font-family: 'Lato';
font-style: normal;
font-weight: 400;
font-size: 13px;
line-height: 20px;
letter-spacing: 0.25px;
color: #666666;

mix-blend-mode: normal;
        }
        span.register-redirect {
          font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 20px;
letter-spacing: 0.25px;
color: #103F5E;
margin-left:127px;
mix-blend-mode: normal;
}
      }
    }

    .email-label {
      font-size: 16px;
    }
    .password-label {
      font-size: 16px;
    }
  }
}
</style>
